export default "__VITE_ASSET__df9ee68e__"